import React, { Component } from "react";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import { auth } from "../../services/firebase";
import { httpClient } from "../../services/data-provider/guide";

class ImportKKblogButton extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick = () => {
    const { onClick } = this.props;
    onClick();
  };

  render() {
    return (
      <Button variant="contained" color="primary" onClick={this.handleClick}>
        [{this.props.lang}] Import {this.props.postId}
      </Button>
    );
  }
}

ImportKKblogButton.propTypes = {
  onClick: PropTypes.func,
  postId: PropTypes.number
};

class ImportKKblog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      result: ""
    };
  }

  import = () => {
    const { postId, lang } = this.props;

    this.setState({ result: `processing...` });
    auth.currentUser
      .getIdToken(false)
      .then(token => {
        return httpClient
          .get(`/api/thirdparty/kkblogs/import/${postId}?lang=${lang}`, {
            token
          })
          .catch(function(error) {
            let message = "api error !!";
            throw message;
          });
      })
      .then(res => {
        const result = res.data;
        if (result.status === "success") {
          this.setState({
            result: `import : ${result.article.title}`
          });
        } else {
          this.setState({
            result: `failure: ${result.error}`
          });
        }
      })
      .catch(error => {
        this.setState({
          result: `failure: ${error}`
        });
      });
  };

  render() {
    return (
      <div style={{ paddingTop: 10 }}>
        <ImportKKblogButton onClick={this.import} {...this.props} />
        <span style={{ marginLeft: 10 }}>{this.state.result}</span>
      </div>
    );
  }
}

ImportKKblog.propTypes = {
  postId: PropTypes.number,
  lang: PropTypes.string
};

export default ImportKKblog;
